<mat-sidenav-container autosizes>
  <mat-sidenav
    #sidenav
    id="phoenix-main-sidenav"
    class="border-none !z-[1000] theme-bg-1 !w-[62px] relative shadow-lg rounded-xl"
    mode="side"
    opened="true"
    [disableClose]="true"
  >
    <!-- Phoenix navigation -->
    <mat-nav-list
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
      [class.sidenav__nav-list--expanded]="isExpanded()"
      class="sidenav__nav-list theme-bg-5 border-color-1 fixed top-0 h-screen !flex flex-col overflow-hidden"
    >
      <div
        class="!flex-1 !overflow-y-auto overflow-x-hidden"
        [class.sidenav__scroll--no-scrollbar]="!isExpanded()"
      >
        <mat-list-item id="phoenix-logo" class="min-h-9 mb-1">
          <a routerLink="/" class="flex items-center min-h-9">
            <span
              class="flex items-center justify-center h-7 w-7 flex-shrink-0"
            >
              <img
                class="h-7 w-7 block"
                src="/assets/images/logo/phoenix_logo_gradient.svg"
                alt="Phoenix logo"
              />
            </span>
            @if (isExpanded()) {
              <span
                class="flex items-center ml-3 transition-opacity duration-300 opacity-100"
              >
                <img
                  class="h-8 block"
                  src="/assets/images/logo/phoenix_text.svg"
                  alt="Phoenix text"
                />
              </span>
            }
          </a>
        </mat-list-item>

        @for (item of navigationItemsSignal(); track item.name) {
          @if (item.permissions ?? [] | permissions | async) {
            @if (!item.children) {
              <!-- Single navigation  -->
              <mat-list-item
                [routerLink]="item.path"
                [ngClass]="{
                  'theme-bg-7--active': urlContains(item.path ?? ''),
                }"
              >
                <div class="flex flex-row">
                  @if (item.svgIcon) {
                    <div
                      [ngStyle]="{
                        'mask-image':
                          'url(/assets/images/icons/sidenav/' +
                          item.svgIcon +
                          '.svg)',
                      }"
                      class="sidenav__svg-icon min-h-[25px] min-w-[25px]"
                    ></div>
                  } @else {
                    <span [class]="item.iconClass">
                      {{ item.icon }}
                    </span>
                  }

                  @if (isExpanded()) {
                    <span
                      class="ml-2 flex flex-row text-base font-medium"
                      [attr.aria-label]="
                        'navigation-' +
                        item.name.toLowerCase().split(' ').join('-')
                      "
                    >
                      {{ item.name }}
                    </span>
                  }
                </div>
              </mat-list-item>
            } @else {
              <!-- Multiple navigation  -->

              <cdk-accordion>
                <cdk-accordion-item
                  #accordionItem="cdkAccordionItem"
                  [attr.aria-expanded]="accordionItem.expanded"
                  [attr.aria-controls]="'accordion-body-' + $index"
                >
                  @if (item.permissions ?? [] | permissions | async) {
                    <mat-list-item
                      [attr.aria-label]="
                        'navigation-' +
                        item.name.toLowerCase().split(' ').join('-')
                      "
                      (click)="accordionItem.toggle()"
                      (keyup)="(null)"
                      [ngClass]="{
                        'theme-bg-7--active': isParentActive(item),
                      }"
                    >
                      <div class="flex flex-row">
                        @if (item.svgIcon) {
                          <div
                            [ngStyle]="{
                              'mask-image':
                                'url(/assets/images/icons/sidenav/' +
                                item.svgIcon +
                                '.svg)',
                            }"
                            class="sidenav__svg-icon min-h-[25px] min-w-[25px]"
                          ></div>
                        } @else {
                          <span [class]="item.iconClass">
                            {{ item.icon }}
                          </span>
                        }
                        @if (isExpanded()) {
                          <span class="ml-2 flex-1">{{ item.name }}</span>
                          <mat-icon
                            [ngClass]="{
                              'rotate-180': accordionItem.expanded,
                              'transition-transform duration-300': true,
                            }"
                          >
                            expand_more
                          </mat-icon>
                        }
                      </div>
                    </mat-list-item>
                  }
                  <div
                    class="sidenav__accordion-content"
                    [ngClass]="{
                      'sidenav__accordion-content--expanded':
                        accordionItem.expanded,
                      'sidenav__accordion-content--collapsed':
                        !accordionItem.expanded,
                    }"
                  >
                    @if (isExpanded()) {
                      @for (subitem of item.children; track subitem.name) {
                        @if (subitem.permissions ?? [] | permissions | async) {
                          <mat-list-item
                            [routerLink]="subitem.path"
                            [ngClass]="{
                              'theme-bg-7--active': urlContains(
                                subitem.path ?? ''
                              ),
                            }"
                          >
                            <div class="flex flex-row pl-5">
                              @if (subitem.svgIcon) {
                                <div
                                  [ngStyle]="{
                                    'mask-image':
                                      'url(/assets/images/icons/sidenav/' +
                                      subitem.svgIcon +
                                      '.svg)',
                                  }"
                                  class="sidenav__svg-icon min-h-[20px] min-w-[20px]"
                                ></div>
                              } @else {
                                <span [class]="'text-sm ' + subitem.iconClass">
                                  {{ subitem.icon }}
                                </span>
                              }
                              <span
                                class="px-2 text-sm"
                                [attr.aria-label]="
                                  'navigation-' +
                                  subitem.name
                                    .toLowerCase()
                                    .split(' ')
                                    .join('-')
                                "
                              >
                                {{ subitem.name }}
                              </span>
                            </div>
                          </mat-list-item>
                        }
                      }
                    }
                  </div>
                </cdk-accordion-item>
              </cdk-accordion>
            }
          }
        }
      </div>

      <!-- Bottom Navigation -->
      <div class="flex flex-col flex-shrink-0 w-full items-stretch mt-auto">
        <div
          class="h-[1px] bg-gray-500 my-3 opacity-40 mx-[10px] rounded"
        ></div>

        <phoenix-downloads-management
          [expanded]="isExpanded()"
        ></phoenix-downloads-management>

        @if (_buildInfo.env !== 'prod') {
          <mat-list-item class="min-h-16">
            <div class="flex flex-row items-center w-full">
              <div
                class="w-6 h-6 min-w-[24px] rounded-full bg-amber-500 flex items-center justify-center text-white font-bold overflow-hidden"
              >
                {{ _buildInfo.env.charAt(0).toUpperCase() }}
              </div>
              @if (isExpanded()) {
                <div class="ml-2 flex flex-col flex-1 min-w-0">
                  @if (_buildInfo.buildBranch) {
                    <span
                      matTooltip="{{ _buildInfo.buildBranch }}"
                      [matTooltipDisabled]="!_buildInfo.buildBranch"
                      class="text-sm w-full truncate"
                      >{{ _buildInfo.buildBranch }}</span
                    >
                    <small class="text-xs text-gray-400 w-full truncate">{{
                      _buildInfo.buildRelativeTime
                    }}</small>
                    @if (_buildInfo.commitSha) {
                      <small
                        class="text-xs text-gray-400 w-full truncate"
                        matTooltip="{{ _buildInfo.commitSha }}"
                      >
                        {{ _buildInfo.commitSha }}
                      </small>
                    }
                  } @else {
                    <span class="text-sm w-full truncate">Localhost</span>
                  }
                </div>
              }
            </div>
          </mat-list-item>
        }
        <mat-list-item class="min-h-11 w-full">
          @if (hasUnreadNotifications()) {
            <span class="absolute flex right-2 top-1 size-3">
              <!-- Notification ping -->
              <span
                class="absolute inline-flex h-full w-full animate-ping rounded-full theme-bg-warning opacity-90"
              ></span>
              <span
                class="relative inline-flex size-3 rounded-full theme-bg-warning"
              ></span>
            </span>
          }
          <div
            class="flex flex-row items-center w-full text-ellipsis"
            [matMenuTriggerFor]="userMenu"
          >
            @if (userImg()) {
              <img
                class="rounded-full cursor-pointer w-7 h-7 flex-shrink-0"
                alt="User"
                [attr.src]="userImg()"
              />
            } @else {
              <span
                class="material-icons-outlined w-7 h-7 flex-shrink-0 flex items-center justify-center"
              >
                account_circle
              </span>
            }
            @if (isExpanded()) {
              <span class="ml-2 truncate">{{ userEmail() }}</span>
            }
          </div>
        </mat-list-item>
        <mat-menu
          #userMenu="matMenu"
          xPosition="after"
          yPosition="above"
          [overlapTrigger]="false"
        >
          @if (featureFlags.isOn('show_yearly_wrapped')) {
            <button
              aria-label="navigation-logout-button"
              mat-menu-item
              [routerLink]="'/wrapped'"
            >
              <div class="flex items-center justify-start">
                <span
                  class="absolute -inset-1 block -skew-y-3 bg-orange-600 scale-y-75"
                  aria-hidden="true"
                ></span>
                <span class="relative material-icons-outlined text-white">
                  calendar_month
                </span>
                <span class="relative ml-1 font-bold text-white">Wrapped!</span>
              </div>
            </button>
          }

          <!-- Themes -->
          <button
            aria-label="navigation-themes-button"
            mat-menu-item
            [matMenuTriggerFor]="themesOptions"
          >
            <div class="flex items-center justify-start">
              <span class="material-icons-outlined"> palette </span>
              <span class="ml-1">Themes</span>
            </div>
          </button>

          <!-- Density -->
          <button
            aria-label="navigation-density-button"
            mat-menu-item
            [matMenuTriggerFor]="densityOptions"
          >
            <div class="flex items-center justify-start">
              <span class="material-icons-outlined"> density_medium </span>
              <span class="ml-1">Density</span>
            </div>
          </button>
          <!-- Logout -->
          <button
            aria-label="navigation-logout-button"
            mat-menu-item
            (click)="authService.logOut()"
          >
            <div class="flex items-center justify-start">
              <span class="material-icons-outlined"> logout </span>
              <span class="ml-1">Log out</span>
            </div>
          </button>
        </mat-menu>
        <mat-menu #densityOptions="matMenu">
          @for (density of densities; track density) {
            <button
              [ngClass]="{
                'theme-bg-7--active': density === _themes.densitySignal(),
              }"
              (click)="changeDensity(density)"
              mat-menu-item
              [disableRipple]="true"
              [attr.aria-label]="'navigation-density' + density"
            >
              {{ getDensity(density)?.replace('_', ' ') | titlecase }}
            </button>
          }
        </mat-menu>
        <mat-menu #themesOptions="matMenu">
          @for (theme of themes; track theme) {
            <button
              [ngClass]="{
                'theme-bg-7--active': theme === _themes.themeSignal(),
              }"
              (click)="changeTheme(theme)"
              mat-menu-item
              [attr.aria-label]="'navigation-themes-' + theme"
            >
              {{ theme | titlecase }}
            </button>
          }
        </mat-menu>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <!-- Application content -->
  <mat-sidenav-content>
    <div class="ml-[10px]">
      <router-outlet></router-outlet></div
  ></mat-sidenav-content>
</mat-sidenav-container>
